// extracted by mini-css-extract-plugin
module.exports = {"isActive":"MobileNavLink_isActive__oR4Ps"};